import type { FaceDetectResult } from '../types';

export const getHintsPhoto = (faceDetectResult: FaceDetectResult): string => {
    if (!faceDetectResult.isFaceFound) {
        return 'docVerificationWidget.liveness.faceNotFound';
    }

    if (!faceDetectResult.isCenter && faceDetectResult.isFaceFound) {
        return 'docVerificationWidget.liveness.alignFace';
    }

    if (!faceDetectResult.isLookingStraight) {
        return 'docVerificationWidget.liveness.lookStraight';
    }

    // if (faceDetectResult.facePercent.hint === 'small') {
    //     return 'docVerificationWidget.liveness.moveCloser';
    // }
    //
    // if (faceDetectResult.facePercent.hint === 'big') {
    //     return 'docVerificationWidget.liveness.backward';
    // }

    if (faceDetectResult.isSuccess) {
        return 'docVerificationWidget.liveness.dontMove';
    }

    return 'docVerificationWidget.liveness.textMask';
};
